import { render } from "./ServiceLayout.vue?vue&type=template&id=5e5614c5"
import script from "./ServiceLayout.vue?vue&type=script&lang=js"
export * from "./ServiceLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__